import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaHeadset } from 'react-icons/fa';

import { ButtonText, RegularText, Text } from '../../common/Text';
import { PrimaryButton } from '../../common/Buttons';
import { fontSize } from '../../../utils';
import CardContainer from '../../common/CardContainer';

import tickIcon from '../../../images/onboarding/greenTick.svg';

const OuterContainer = styled(CardContainer)`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0.25rem 0;
`;

const BubbleContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0.625rem 0.75rem;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const MessageText = styled(RegularText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  margin: 0.5rem 0;
`;

const HeadsetIcon = styled(FaHeadset)`
  margin-right: 0.75rem;
  color: white;
`;

const LocationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-self: stretch;
  align-items: center;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '0')};
`;

const StyledButtonText = styled(ButtonText)`
  font-size: ${fontSize(0.875)};
`;

const ConfirmedContainer = styled.div`
  margin-top: 0.875rem;
  display: flex;
  align-items: center;
`;

const ConfirmIcon = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 0.625rem;
`;

const ConfirmText = styled(Text)`
  color: #59ba29;
  flex: 1;
  font-size: ${fontSize(0.875)};
`;

const UrgentAssistanceMessage = ({
  className,
  text,
  onUrgentAssistanceClicked,
  showConfirmed,
}) => (
  <OuterContainer className={className}>
    <BubbleContainer>
      <MessageContainer>
        <MessageText>{text}</MessageText>
      </MessageContainer>
      {showConfirmed ? (
        <ConfirmedContainer>
          <ConfirmIcon src={tickIcon} />
          <ConfirmText>
            Request received! one of our executives will reach out to you in
            sometime
          </ConfirmText>
        </ConfirmedContainer>
      ) : (
        <PrimaryButton onTap={onUrgentAssistanceClicked}>
          <LocationContainer>
            <HeadsetIcon />
            <StyledButtonText>NEED URGENT ASSISTANCE</StyledButtonText>
          </LocationContainer>
        </PrimaryButton>
      )}
    </BubbleContainer>
  </OuterContainer>
);

UrgentAssistanceMessage.propTypes = {
  text: PropTypes.string,
  onUrgentAssistanceClicked: PropTypes.func,
  showConfirmed: PropTypes.bool,
};

export default UrgentAssistanceMessage;
